import { useEffect, useMemo, useState } from "react";
import { compose } from "redux";

// markup
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";

// custom markup
import RefreshButton from "../../../../shared/ui/Refresh.Button";

// account balance view
import Link from "admin/shared/ui/Link.Component";
import AccountBalance from "./Dashboard.Account.Balance.Component";
import { dashboardConnector } from "../../../../services/menu/dashboard/connector";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { AppBar } from "@material-ui/core";
import { applicationConnector } from "../../../../services/applications/connector";

const DashboardOverviewComponent = (props) => {
  const [activeCurrencyTab, setActiveCurrencyTab] = useState("SEK");

  useEffect(() => {
    props.getCreditApplications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const refreshBtnClick = () => {
    props.fetchDashboardLoanData();
  };

  const applicationsLen = useMemo(() => {
    return props.applications ? props.applications.length : 0;
  }, [props.applications]);

  const handleChangeTab = (e, value) => setActiveCurrencyTab(value);

  let financingsLen = props.financings
    ? props.financings.filter((f) => !f.Published).length
    : 0;
  let payoutLen = props.loanpayouts ? props.loanpayouts.length : 0;
  let activeColor = { backgroundColor: "rgb(57, 90, 90)" };

  return (
    <div>
      <RefreshButton onRefreshClick={refreshBtnClick} />
      <div
        className="dashboard-layout body-height content-padding"
        style={{ display: "flex", flexWrap: "wrap" }}
      >
        <List>
          <Link toState={"newCreditApplications"}>
            <ListItem>
              <ListItemAvatar>
                <Avatar {...(applicationsLen ? activeColor : {})}>
                  {applicationsLen}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                id="appAwaitingReview"
                primary="Applications awaiting review"
              />
            </ListItem>
          </Link>
          <Link toState={"credits"}>
            <ListItem>
              <ListItemAvatar>
                <Avatar {...(financingsLen ? activeColor : {})}>
                  {financingsLen}
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Financings awaiting publishing" />
            </ListItem>
          </Link>
          <Link toState={"newLoansPayout"}>
            <ListItem>
              <ListItemAvatar>
                <Avatar {...(payoutLen ? activeColor : {})}>{payoutLen}</Avatar>
              </ListItemAvatar>
              <ListItemText primary="Payouts awaiting" />
            </ListItem>
          </Link>
        </List>
      </div>

      <AppBar position="static" color="default">
        <Tabs
          variant="fullWidth"
          value={activeCurrencyTab}
          onChange={handleChangeTab}
        >
          <Tab label="SEK" value="SEK" />
          <Tab label="EUR" value="EUR" />
        </Tabs>
      </AppBar>

      {activeCurrencyTab === "SEK" && (
        <div className="content-padding">
          <AccountBalance currency={"SEK"} />
        </div>
      )}
      {activeCurrencyTab === "EUR" && (
        <div className="content-padding">
          <AccountBalance currency={"EUR"} />
        </div>
      )}
    </div>
  );
};
export default compose(
  applicationConnector,
  dashboardConnector,
)(DashboardOverviewComponent);
